<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="signTime" >
        <span slot="label" >
          <a-tooltip>
            {{$t('直播签到.观看多长时间可获得积分')}}<template slot="title">{{$t('直播签到.观看多长时间可获得积分')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.signTime"  :placeholder="$t('通用.输入.请输入')+$t('直播签到.观看多长时间可获得积分')" />
      </a-form-model-item>
      <a-form-model-item prop="signSum" >
        <span slot="label" >
          <a-tooltip>
            {{$t('直播签到.获得积分数量')}}<template slot="title">{{$t('直播签到.获得积分数量')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.signSum"  :placeholder="$t('通用.输入.请输入')+$t('直播签到.获得积分数量')" />
      </a-form-model-item>
      <a-form-model-item prop="isReceipt" >
        <span slot="label" >
          <a-tooltip>
            {{$t('直播签到.是否需要回执')}}<template slot="title">{{$t('直播签到.是否需要回执')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.isReceipt"  :placeholder="$t('通用.输入.请输入')+$t('直播签到.是否需要回执')" />
      </a-form-model-item>
      <a-form-model-item prop="receiptTime" >
        <span slot="label" >
          <a-tooltip>
            {{$t('直播签到.回执时间')}}<template slot="title">{{$t('直播签到.回执时间')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.receiptTime"  :placeholder="$t('通用.输入.请输入')+$t('直播签到.回执时间')" />
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" >
          <a-tooltip>
            {{$t('直播签到.备注')}}<template slot="title">{{$t('直播签到.备注')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getLiveSign, addLiveSign, updateLiveSign } from '@/api/live/liveSign'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        signTime: null,

        signSum: null,

        isReceipt: null,

        receiptTime: null,

        createTime: null,

        remark: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        signTime: null,
        signSum: null,
        isReceipt: null,
        receiptTime: null,
        createTime: null,
        remark: null
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getLiveSign({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateLiveSign(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addLiveSign(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
